import { makeStyles, tokens } from '@fluentui/react-components';

export const useStyles = makeStyles({
  submitError: {
    color: tokens.colorPaletteRedForeground1,
    marginTop: tokens.spacingVerticalS,
    fontSize: tokens.fontSizeBase300,
  },
});
